import React, { useEffect, useState } from 'react';
import { arrayMoveImmutable } from 'array-move';

import { withRouter, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import queryString from 'query-string';
import {
  getTeamData,
  updateTeam,
  updateSkill,
  getConfluenceSpaces,
} from '../../skills_action';

import {
  Button,
  PageHeader,
  Row,
  Col,
  Card,
  Tooltip,
  Table,
  Typography,
  Tag,
  Switch,
  Select,
  Image,
  Input,
  Modal,
  Tabs,
  Divider,
  Radio,
} from 'antd';
import AppHome from '../AppHome/Apphome';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc';

import { MenuOutlined } from '@ant-design/icons';

const { Option } = Select;

const { Text, Title } = Typography;
const { TabPane } = Tabs;

const SlackApp = (props) => {
  const dispatch = useDispatch();

  const team = useSelector((state) => {
    return state.common_reducer.team;
  });
  const isAdmin = useSelector((state) => state.common_reducer.isAdmin);

  const botName = useSelector((state) => {
    //  console.log(state)
    if (state.common_reducer.team) {
      return state.common_reducer.team.assisantName;
    } else {
      return null;
    }
  });
  const dBotBehaviour = useSelector((state) => {
    //  console.log(state.common_reducer.team)
    if (state.common_reducer.team) {
      return state.common_reducer.team.botBehaviour;
    } else {
      return null;
    }
  });
  const cSkill = useSelector((state) => {
    // console.log(state)
    let skill = null;
    if (state.skills.skills && state.skills.skills.length > 0) {
      skill = state.skills.skills.find((s) => s.key === 'wiki');
      skill = skill && skill.skill_metadata ? skill.skill_metadata : skill;
    }
    return skill;
  });
  const spaces = useSelector((state) => {
    // console.log(state)
    return state.skills.confluence_spaces;
  });
  const isEnterPrise = useSelector((state) => {
    // console.log(state)
    if (state.common_reducer.workspace) {
      return state.common_reducer.workspace.is_enterprise;
    }
  });

  const skillsState = useSelector((state) => state.skills.skills);
  const wikiSkill = skillsState.find((skill) => skill.key === 'wiki');

  const matching_type_options = [
    { label: 'Tight', value: 'tight' },
    { label: 'Loose', value: 'loose' },
  ];

  const matching_scope_options = [
    { label: 'Title, Label', value: 'title' },
    { label: 'Title, Label, Content', value: 'all' },
    { label: 'Label', value: 'label' },
  ];
  const initalNoResultMessage =
    'We do not have an answer right now. Do you want our team to look into this request?';
  // const isSkillEnabled=cSkill&&cSkill.disabled

  const [botBehaviour, setBotBehaviour] = useState('command');
  const [assisantName, setBotName] = useState(null);
  const [visible, openSpaceModal] = useState(false);
  const [loading, submitLoad] = useState(false);
  const [selected_spaces, addSpace] = useState([]);
  const [config_spaces, addFullSpace] = useState([]);
  const [isKeywordSearchActive, updateKeywordSearch] = useState(true);
  const [searchContent, updateConetentSearch] = useState(false);
  const [showCreateButton, showCreate] = useState(false);
  const [channelType, changeChannelType] = useState('support');
  const [currentTab, setTab] = useState('bot_behaviour');
  const [searchBy, setSearchBy] = useState('title');
  const [noResultMessage, set_noResultMessage] = useState(
    initalNoResultMessage
  );
  const [noResultMessageModalVisible, set_noResultMessageModalVisible] =
    useState(false);
  //ankit
  const [customLabelsSearch, setcustomLabelsSearch] = useState([]);

  useEffect(() => {
    setBotBehaviour(dBotBehaviour);
  }, [dBotBehaviour]);

  useEffect(() => {
    if (!botName) {
      dispatch(getTeamData(props.match.params.wId));
    }
    let confSkill = cSkill;
    if (!cSkill) {
      // cSkill=await
    }

    if (confSkill && confSkill.globalDefaults) {
      if (
        confSkill.globalDefaults.spaces &&
        confSkill.globalDefaults.spaces.length > 0 &&
        config_spaces.length == 0
      ) {
        let spaces = confSkill.globalDefaults.spaces;
        let spacesId = spaces.map((sp) => sp.id);
        addSpace(spacesId);
        addFullSpace(spaces);
      }
      const isKeywordSearchActiveType =
        confSkill &&
        confSkill.globalDefaults &&
        confSkill.globalDefaults.hasOwnProperty('isKeywordSearchActive')
          ? confSkill.globalDefaults.isKeywordSearchActive
            ? true
            : false
          : true;
      setcustomLabelsSearch(confSkill.globalDefaults.customLabelsSearch || []);
      if (isKeywordSearchActiveType !== isKeywordSearchActive) {
        updateKeywordSearch(confSkill.globalDefaults.isKeywordSearchActive);
      }

      if (confSkill.globalDefaults.searchContent !== searchContent) {
        updateConetentSearch(confSkill.globalDefaults.searchContent);
      }
      if (confSkill.globalDefaults.searchBy !== searchBy) {
        setSearchBy(confSkill.globalDefaults.searchBy);
      }

      if (confSkill.globalDefaults.showCreateButton !== showCreateButton) {
        showCreate(confSkill.globalDefaults.showCreateButton);
      }
      if (confSkill.globalDefaults.channelType !== channelType) {
        changeChannelType(confSkill.globalDefaults.channelType);
      }

      if (confSkill.globalDefaults.noResultMessage)
        set_noResultMessage(confSkill.globalDefaults.noResultMessage);
    }

    let parsedQueryString = queryString.parse(window.location.search);
    if (
      parsedQueryString.view &&
      (parsedQueryString.view == 'bot_name' || 'bot_behaviour') &&
      parsedQueryString.view !== currentTab
    ) {
      setTab(parsedQueryString.view);
    }
  }, [cSkill]);

  const onJiraProjectTypeChange = async (event) => {
    let value = event.target.value;

    let globalDefaults = cSkill.globalDefaults || {};
    globalDefaults.channelType = value;
    let res = await dispatch(
      updateSkill(cSkill._id, props.match.params.wId, { globalDefaults })
    );

    changeChannelType(value);
  };
  const updateCreateButton = async (value) => {
    // console.log("here1",value)

    let globalDefaults = cSkill.globalDefaults || {};
    globalDefaults.showCreateButton = value;
    showCreate(value);
    let res = await dispatch(
      updateSkill(cSkill._id, props.match.params.wId, { globalDefaults })
    );
  };
  const changeContentSearch = async (event) => {
    let value = event.target.value;
    setSearchBy(value);
    let globalDefaults = cSkill.globalDefaults || {};
    globalDefaults.searchBy = value;
    let res = await dispatch(
      updateSkill(cSkill._id, props.match.params.wId, { globalDefaults })
    );
  };
  const hangeKeywordSearch = async (event) => {
    let value = event.target.value;

    updateKeywordSearch(value === 'tight' ? false : true);
    let globalDefaults = cSkill.globalDefaults || {};
    globalDefaults.isKeywordSearchActive = value === 'tight' ? false : true;
    let res = await dispatch(
      updateSkill(cSkill._id, props.match.params.wId, { globalDefaults })
    );
    // console.log(res)
  };

  const getIndividualLabels = (items = []) => {
    let output = [];
    items.forEach((el) => {
      let elArray = el.split(' ');
      output = [...output, ...elArray];
    });
    return output.filter((el) => el);
  };

  const updateCustomLabelsSearch = async (values) => {
    values = getIndividualLabels(values);
    setcustomLabelsSearch(values);
    let globalDefaults = cSkill.globalDefaults || {};
    globalDefaults.customLabelsSearch = values;
    let res = await dispatch(
      updateSkill(cSkill._id, props.match.params.wId, { globalDefaults })
    );
  };

  const handleOk = async () => {
    submitLoad(true);
    let globalDefaults = cSkill.globalDefaults || {};
    globalDefaults.spaces = config_spaces;
    let res = await dispatch(
      updateSkill(cSkill._id, props.match.params.wId, { globalDefaults })
    );

    submitLoad(false);

    openSpaceModal(false);
  };
  const onChangeSpaces = (event, data) => {
    // console.log(data)

    addSpace(event);
    //   spaces:
  };
  const onChangeTab = (val) => {
    // console.log(val)
    setTab(val);
    props.history.push(`/${props.match.params.wId}/slackApp?view=${val}`);
  };
  const removeSpace = (val) => {
    let selected_spaces = config_spaces.filter((space) => space.id != val);
    addFullSpace(selected_spaces);
  };
  const addSelectedSpaces = (val) => {
    let selected_spaces = config_spaces;
    let exits = selected_spaces.find((space) => space.id == val);
    if (!exits) {
      //  console.log(this.props.spaces)
      let space = spaces.find((space) => space.id == val);

      selected_spaces.push(space);
      // console.log(config_spaces)
      addFullSpace(selected_spaces);
    } else {
      // console.log("here")
      let newSpaces = selected_spaces.filter((space) => space.id !== val);
      // console.log("here",newSpaces)
      addFullSpace(newSpaces);
    }
  };
  const handleCancel = () => {
    openSpaceModal(false);
  };

  const updateSlackTeam = () => {
    let data = { assisantName: assisantName };
    dispatch(updateTeam(props.match.params.wId, data));
  };
  const handleNameChange = (e) => {
    // console.log(e)

    setBotName(e.target.value);
  };
  // const submitName=()=>{

  //   updateSlackTeam

  // }

  // globalDefaults
  // setBotName

  // {"success":true,"config":{"id":"62fca6066cb4c52e7e3c0d3a","spaces":[],"isKeywordSearchActive":true,"showCreateButton":true,"channel_admins":[],"restrict_channel_config":false,"searchContent":false,"channelType":"support","workspace_id":"60b713974e6cc132ba0a991e","channel":{"id":"C03M466KESG","name":"op"},"auto_suggest":true,"skill_id":"61484d16c785a12276f6e20f","updated_by":{"_id":"60b7139860cb173b7b4d3ae8","name":"vishvadeep","email":"vishvadeep@troopr.io","user_id":"603c8f9946196a7cfcd29921","displayName":"Vishavdeep Singh Rao"},"created_by":{"_id":"60b7139860cb173b7b4d3ae8","name":"vishvadeep","email":"vishvadeep@troopr.io","user_id":"603c8f9946196a7cfcd29921","displayName":"Vishavdeep Singh Rao"},"created_at":"2022-08-17T08:25:42.080Z","updatedAt":"2022-08-17T08:25:42.080Z","_v":0}}
  const onBehaviourChange = (e) => {
    setBotBehaviour(e.target.value);

    dispatch(
      updateTeam(props.match.params.wId, { botBehaviour: e.target.value })
    );
    // dispatch(updateSkill(cSkill._id, cSkill.workspace_id, {isBotChannel=type=="wiki"?true:false})))
  };
  const wikiSkillId = useSelector((state) => {
    const findSkill = state.skills.skills.find((skill) => skill.key === 'wiki');
    if (findSkill && findSkill.skill_metadata && findSkill.skill_metadata._id) {
      return findSkill.skill_metadata._id;
    }
    return '';
  });
  const getBotBehaviourText = () => {
    if (botBehaviour === 'command') {
      return (
        <>
          Troopr will try to interpret commands if any in the message. See list
          of available commands{' '}
          <Link to={`/${team.workspace_id}/commands`}>here</Link>.
        </>
      );
    } else {
      return (
        <>
          Troopr will consider the messages as help requests and make
          suggestions for solution from Wiki. "Troopr Wiki" product should be
          enabled{' '}
          <Link to={`/${team.workspace_id}/settings?view=product`}>
            (enable now)
          </Link>{' '}
          and should be connected to Confluence{' '}
          <Link
            to={`/${team.workspace_id}/skills/${wikiSkillId}?view=connection`}
          >
            (connect now)
          </Link>{' '}
          for this feature.
        </>
      );
    }
  };

  const openSettingModal = async () => {
    let res = await dispatch(getConfluenceSpaces(props.match.params.wId));
    let _obj = {};
    openSpaceModal(true);
  };

  //ankit

  const handleNoResultMessageUpdate = async () => {
    let globalDefaults = cSkill.globalDefaults || {};
    globalDefaults.noResultMessage = noResultMessage;
    const res = await dispatch(
      updateSkill(cSkill._id, props.match.params.wId, { globalDefaults })
    );
    if (res.data.success) set_noResultMessageModalVisible(false);
  };

  const handleNoResultModalCancel = () => {
    set_noResultMessageModalVisible(false);
    set_noResultMessage(
      cSkill && cSkill.globalDefaults && cSkill.globalDefaults.noResultMessage
        ? cSkill.globalDefaults.noResultMessage
        : initalNoResultMessage
    );
  };

  return (
    <div>
      {/* { console.log(cSkill)} */}
      <PageHeader
        style={{ padding: '10px  24px 0px 24px', maxHeight: '8vh' }}
        title='Slack App'
        subTitle={`Setup default app home ${
          wikiSkill && wikiSkill.skill_metadata ? '& bot behaviour' : ''
        } for everyone in Slack`}
      ></PageHeader>
      {wikiSkill && wikiSkill.skill_metadata ? (
        <div style={{ margin: '0px 32px', padding: '0px' }}>
          <Tabs
            // tabPosition="left"
            defaultActiveKey={currentTab}
            onChange={onChangeTab}
            // onTabClick={() => this.setEditing(false)}
            activeKey={currentTab}
            style={{ maxHeight: '8vh' }}
          >
            <TabPane tab='Bot behaviour' key='bot_behaviour' />
            {isEnterPrise && <TabPane tab='Bot name' key='bot_name' />}
            <TabPane tab='Apphome' key='appHome' />
            {/* <TabPane tab="App home" key="appHome" /> */}
          </Tabs>
          {/* { console.log(currentTab)}
(parsedQueryString.view =='bot_name'||'bot_behaviour') */}
          {currentTab === '1' ? (
            <>
              <div>
                Currently using Team defaults. <a>Click here to customize</a>
              </div>
            </>
          ) : currentTab === 'bot_name' ? (
            <Row gutter={[16, 16]} style={{ overflow: 'auto', height: '80VH' }}>
              <Col span={20} style={{ display: 'flex' }}>
                <div style={{ marginBottom: 32 }}>
                  <Card
                    title={
                      <>
                        <Text style={{ marginRight: 8 }}>App name</Text>
                        <Tag color='green'>Enterprise</Tag>
                      </>
                    }
                  >
                    <div style={{ marginBottom: 8 }}>
                      <Text>In messages: </Text>
                      <Text type='secondary'>
                        Customize the name of the app in the messages Troopr
                        posts to your Slack channels
                      </Text>
                    </div>
                    <div>
                      <Input
                        disabled={!isAdmin}
                        style={{ width: 500 }}
                        onChange={(e) => handleNameChange(e)}
                        value={
                          assisantName !== null
                            ? assisantName
                            : botName
                            ? botName
                            : 'Trooprs Assistant'
                        }
                      />

                      <Button
                        type='primary'
                        style={{ marginLeft: '30px' }}
                        onClick={() => updateSlackTeam()}
                        disabled={
                          !isAdmin ||
                          !assisantName ||
                          (assisantName && assisantName === botName)
                        }
                      >
                        Change Name
                      </Button>
                    </div>
                    <Divider />
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'start',
                      }}
                    >
                      <div style={{ flexGrow: 2, marginRight: 32 }}>
                        <div style={{ marginBottom: 16 }}>
                          <Text>In sidebar: </Text>
                          <Text type='secondary'>
                            To change the name of the "Troopr Assistant" app in
                            Slack sidebar,{' '}
                            <a
                              target='_blank'
                              href='https://my.slack.com/apps/AE4FF42BA-troopr-assistant?tab=settings'
                            >
                              go to your app configuration
                            </a>{' '}
                            and change the bot name in the settings tab.
                          </Text>
                        </div>
                        <div>
                          <Button
                            disabled={!isAdmin}
                            target='_blank'
                            href='https://my.slack.com/apps/AE4FF42BA-troopr-assistant?tab=settings'
                          >
                            Go to app configuration
                          </Button>
                        </div>
                      </div>
                      <div style={{ flexGrow: 1 }}>
                        <Image
                          width={200}
                          src='https://i.ibb.co/BngLQ93/Xnapper-2022-08-12-13-05-35.png'
                        />
                      </div>
                    </div>
                  </Card>
                </div>
              </Col>
            </Row>
          ) : currentTab === 'bot_behaviour' ? (
            <Row gutter={[16, 16]} style={{ overflow: 'auto', height: '80VH' }}>
              {/* <div style={{ marginTop: 16 ,overflow:"auto"}}>
              <Col span={20} style={{ display: 'flex' }}>
                <div style={{ marginBottom: 32 }}>
                  <Card
                    title={
                      <>
                        <Text style={{ marginRight: 8 }}>App name</Text>
                        <Tag color="green">Enterprise</Tag>
                      </>
                    }
                  >
                    <div style={{ marginBottom: 8 }}>
                      <Text>In messages: </Text>
                      <Text type="secondary">
                        Customize the name of the app in the messages Troopr
                        posts to your Slack channels
                      </Text>
                    </div>
                    <div>

                      <Input disabled={!isAdmin} style={{ width: 500 }} onChange={(e) => handleNameChange(e)}  value={(assisantName!==null)?assisantName:botName?botName:"Trooprs Assistant"} />

                      <Button       type='primary' style={{marginLeft:"30px"}}onClick={()=>updateSlackTeam()} disabled={!isAdmin||(!assisantName||(assisantName&&assisantName===botName))}>Change Name</Button>
                    </div>
                    <Divider />
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'start',
                      }}
                    >
                      <div style={{ flexGrow: 2, marginRight: 32 }}>
                        <div style={{ marginBottom: 16 }}>
                          <Text>In sidebar: </Text>
                          <Text type="secondary">
                            To change the name of the "Troopr Assistant" app in
                            Slack sidebar,{' '}
                            <a target="_blank" href="https://my.slack.com/apps/AE4FF42BA-troopr-assistant?tab=settings">
                              go to your app configuration
                            </a>{' '}
                            and change the bot name in the settings tab.
                          </Text>
                        </div>
                        <div>
                          <Button disabled={!isAdmin} target="_blank" href="https://my.slack.com/apps/AE4FF42BA-troopr-assistant?tab=settings">Go to app configuration</Button>
                        </div>
                      </div>
                      <div style={{ flexGrow: 1 }}>
                        <Image
                          width={200}
                          src="https://i.ibb.co/BngLQ93/Xnapper-2022-08-12-13-05-35.png"
                        />
                      </div>
                    </div>
                  </Card>
                </div>
                </Col> */}

              <Col span={20} style={{ display: 'flex' }}>
                <div style={{ marginBottom: 8, width: '100%' }}>
                  <Card title='Bot channel behaviour'>
                    <div style={{ marginBottom: 16 }}>
                      <Text type='secondary'>
                        Customize how Troopr will react when users post DM
                        messages in the "Troopr Assistant" channel
                      </Text>
                    </div>
                    {/* <Divider /> */}
                    <div style={{ marginBottom: 8 }}>
                      <Radio.Group
                        value={botBehaviour}
                        onChange={onBehaviourChange}
                      >
                        <Radio disabled={!isAdmin} value={'command'}>
                          Command processor
                        </Radio>
                        (
                        {cSkill && cSkill.disabled ? (
                          <Tooltip title='Wiki Skill should be enabled to use this feature.'>
                            <Radio
                              value={'wiki'}
                              disabled={cSkill && cSkill.disabled}
                            >
                              Auto suggest
                            </Radio>
                          </Tooltip>
                        ) : (
                          <Radio
                            value={'wiki'}
                            disabled={cSkill && cSkill.disabled}
                          >
                            Auto suggest
                          </Radio>
                        )}
                      </Radio.Group>
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <Text type='secondary'>{getBotBehaviourText()}</Text>
                    </div>{' '}
                  </Card>
                </div>
              </Col>
              {botBehaviour === 'wiki' && (
                <>
                  <Col span={20} style={{ display: 'flex' }}>
                    <Card
                      title='Confluence Spaces'
                      style={{ width: '100%' }}
                      // size="small"
                      extra={<Button onClick={openSettingModal}>Manage</Button>}
                    >
                      <Text type='secondary'>
                        Configure Confluence spaces for this channel. Articles
                        from the configured spaces will be looked up for
                        suggestions for requests made in this channel.
                      </Text>
                      <br />
                      <br />
                      <Text bold>
                        Connected Spaces:{' '}
                        <Text type='secondary'>
                          {config_spaces.length > 0 ? (
                            <Text type='secondary'>
                              {config_spaces.map((s) => s.name).join(',')}
                            </Text>
                          ) : (
                            <Text type='secondary'>All Spaces</Text>
                          )}{' '}
                        </Text>{' '}
                      </Text>

                      <br />
                      <br />
                      <Modal
                        maskClosable={false}
                        title='Spaces'
                        visible={visible}
                        onOk={handleOk}
                        onCancel={handleCancel}
                        okText={'Submit'}
                        confirmloading={loading}
                      >
                        <b>Select spaces</b>
                        <Select
                          mode='multiple'
                          placeholder='Select a value'
                          style={{ width: '100%' }}
                          value={selected_spaces}
                          // defaultValue={this.state.fieldSelectedCompact && this.state.fieldSelectedCompact.field.name}

                          // placeholder="Select Spaces"
                          optionFilterProp='children'
                          // labelInValue={true}
                          showSearch={true}
                          onChange={(value, data) =>
                            onChangeSpaces(value, data, 'labels')
                          }
                          onSelect={addSelectedSpaces}
                          onDeselect={removeSpace}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {spaces.map((space) => {
                            //   console.log(space.key)
                            return (
                              <Option key={space.key} value={space.id}>
                                {space.name}
                              </Option>
                            );
                          })}
                        </Select>
                        <br />
                        <br />
                      </Modal>
                    </Card>
                  </Col>

                  <Col span={20} style={{ display: 'flex' }}>
                    <Card
                      title='Matching Options'
                      style={{ width: '100%' }}
                      // size="small"
                    >
                      <div>
                        <Text type='secondary'>
                          Tune the confluence search behaviour in this channel.
                        </Text>
                      </div>
                      <Divider />
                      <div>
                        <Text strong>Matching Type</Text>
                      </div>
                      <div>
                        <Text type='secondary'>
                          Use loose matching to find articles where any of the
                          keywords or phrases in the message match OR use tight
                          matching type to match articles only when all keywords
                          or phrases match.
                        </Text>
                      </div>
                      <div>
                        <Radio.Group
                          options={matching_type_options}
                          // disabled={this.state.restrictAccess}
                          onChange={hangeKeywordSearch}
                          value={isKeywordSearchActive ? 'loose' : 'tight'}
                          optionType='button'
                          buttonStyle='solid'
                        />
                      </div>
                      <Divider />
                      <div>
                        <Text strong>Matching Scope</Text>
                      </div>
                      <div>
                        <Text type='secondary'>
                          Confluence pages will be found based on matches found
                          in selected fields of the page.
                        </Text>
                      </div>
                      <div>
                        <Radio.Group
                          options={matching_scope_options}
                          // disabled={this.state.restrictAccess}
                          onChange={changeContentSearch}
                          value={
                            searchBy
                              ? searchBy
                              : searchContent
                              ? 'all'
                              : 'title'
                          }
                          optionType='button'
                          buttonStyle='solid'
                        />
                      </div>
                      <Divider />
                      <Title level={5}>Matching Filter</Title>
                      <Text type='secondary'>
                        Show only matches from Confluence pages that have the
                        following labels on them
                      </Text>
                      <Select
                        placeholder='Defaults to no labels'
                        mode='tags'
                        style={{
                          width: '100%',
                        }}
                        onChange={(items) => updateCustomLabelsSearch(items)}
                        tokenSeparators={[',']}
                        value={customLabelsSearch}
                        options={(customLabelsSearch || []).map((item) => {
                          return {
                            value: item,
                            label: item,
                          };
                        })}
                      />
                      <br />
                    </Card>
                  </Col>

                  <Col span={20}>
                    <Card
                      title='Suggest Request creation'
                      key='1'
                      // size="small"
                      extra={
                        <Switch
                          checked={showCreateButton}
                          // defaultChecked
                          // disabled={this.state.restrictAccess}
                          onClick={updateCreateButton}
                        />
                      }
                    >
                      <Text type='secondary'>
                        Present option to create request in Jira when Confluence
                        suggestions does not resolve the request.
                      </Text>
                      <Divider />
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                        }}
                      >
                        <div style={{ marginBottom: 8 }}>
                          <Text strong>No results message: </Text>
                          <Text type='secondary'>
                            {cSkill &&
                            cSkill.globalDefaults &&
                            cSkill.globalDefaults.noResultMessage
                              ? cSkill.globalDefaults.noResultMessage
                              : initalNoResultMessage}
                          </Text>
                        </div>
                        <div style={{ marginBottom: 8 }}>
                          <Button
                            onClick={() =>
                              set_noResultMessageModalVisible(true)
                            }
                            disabled={!showCreateButton}
                          >
                            Customize
                          </Button>
                        </div>
                      </div>
                      <Modal
                        visible={noResultMessageModalVisible}
                        onCancel={() => handleNoResultModalCancel()}
                        onOk={() => handleNoResultMessageUpdate()}
                        title={
                          <>
                            Customize No results message{' '}
                            <Text type='secondary'>(Max 250 characters)</Text>
                          </>
                        }
                        maskClosable={false}
                        okText='Update'
                      >
                        <>
                          <Input.TextArea
                            maxLength={250}
                            value={noResultMessage}
                            onChange={(e) =>
                              set_noResultMessage(e.target.value)
                            }
                          />
                        </>
                      </Modal>
                      <Divider />
                      <div>
                        <div style={{ marginBottom: 8 }}>
                          <div>
                            <Text strong>Jira Project Type</Text>
                          </div>
                          <Text type='secondary'>
                            Choose the type of Jira project to use
                          </Text>
                        </div>
                        <div style={{ marginBottom: 8 }}>
                          <Radio.Group
                            disabled={!showCreateButton}
                            defaultValue={channelType}
                            onChange={onJiraProjectTypeChange}
                          >
                            <Radio value={'project'}>
                              Use Jira Software project
                            </Radio>
                            <Radio value={'support'}>
                              Use Jira Service Management project
                            </Radio>
                          </Radio.Group>
                        </div>
                        {/* <div>
                            <Button>Customize</Button>
                          </div> */}
                      </div>
                    </Card>
                  </Col>
                </>
              )}
            </Row>
          ) : currentTab === 'appHome' ? (
            <AppHome isAdminApphome={true} isAdmin={isAdmin} />
          ) : (
            ''
          )}
        </div>
      ) : (
        <div style={{ padding: '10px  24px 0px 24px' }}>
          <AppHome
            isAdminApphome={true}
            isAdmin={isAdmin}
            hasWikiSkill={wikiSkill && wikiSkill.skill_metadata}
          />
        </div>
      )}
    </div>
  );
};

export default withRouter(SlackApp);
